import type { Issue } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/issues/types.tsx';
import type { IssueLink } from '@atlassian/jira-portfolio-3-portfolio/src/common/api/types.tsx';
import type { GroupBy } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/dependencies/filters/types.tsx';

export type Measurements = {
	height: number;
	width: number;
};

export type Rect = Measurements & {
	left: number;
	top: number;
};

export type Link = {
	label: string;
	isRollup: boolean;
	links: (IssueLink & { isOfftrack?: boolean })[];
	highlight: boolean;
	isNegativeLeadTime: boolean;
};

const NONE = 'none';
const TEAM = 'team';
const HIERARCHY = 'hierarchy';

export const ROLLUP_BY_OPTION = {
	NONE,
	HIERARCHY,
	TEAM,
};

export const UNASSIGNED = 'unassigned';

export const NO_PARENT_GROUP_SUFFIX = 'no_parent_group';

export const OTHER_GROUP_ID = 'other';

export const GROUP_BY_SPRINT_FIELD = 'groupBySprintField';
export type IssueWithGroupBySprintProp = Issue & {
	[GROUP_BY_SPRINT_FIELD]?: number | string;
};

export type GroupByNotNoneType = 'groupBySprintField' | Exclude<GroupBy, 'none' | 'epic_level'>;

export type LayoutErrorResponse = { ranker: string; error: Error | undefined };

export type IssueLinkWithOfftrack = IssueLink & { isOfftrack?: boolean };
